import IText from '@/components/inputs/i-text.vue';
import IEmail from '@/components/inputs/i-email.vue';
import ICpf from '@/components/inputs/i-cpf.vue';
import ICpfCnpj from '@/components/inputs/i-cpf-cnpj.vue';
import ITel from '@/components/inputs/i-tel.vue';
import IDate from '@/components/inputs/i-date.vue';
import IFile from '@/components/inputs/i-file.vue';
import IOptions from '@/components/inputs/i-options.vue';
import ICheckbox from '@/components/inputs/i-checkbox.vue';
import ITextarea from '@/components/inputs/i-textarea.vue';
import IUf from '@/components/inputs/i-uf.vue';
import ICep from '@/components/inputs/i-cep.vue';
import IFakeTicket from '@/components/inputs/i-fake-ticket.vue';
import IDisclaimer from '@/components/inputs/i-disclaimer.vue';
import IInstrucoes from '@/components/inputs/i-instrucoes.vue';
// i-doc-cpf-cnpj.vue desabilitado (requer vue-the-mask) - usando i-cpf-cnpj.vue com maska

/**
 * Mapeia field.type (do backend) para componente Vue
 * Lembre-se: tailwind classes para largura são aplicadas no DynamicField
 */
export const FIELD_COMPONENT_MAP = {
  // Texto
  'text': IText,
  'textarea': ITextarea,
  'string': IText,
  'name': IText,
  'gender': IOptions,

  // Email
  'email': IEmail,

  // Telefone
  'phone': ITel,
  'tel': ITel,
  'telefone': ITel,

  // CPF/CNPJ
  'cpf': ICpf,
  'cpf_cnpj': ICpfCnpj,
  'document': ICpfCnpj,
  'cnpj': ICpfCnpj,

  // Data
  'date': IDate,
  'birth_date': IDate,
  'data': IDate,

  // CEP
  'cep': ICep,

  // Select/Radio/Checkbox
  'select': IOptions,
  'radio': IOptions,
  'checkbox': ICheckbox,
  'multiselect': IOptions,

  // Arquivo
  'file': IFile,
  'image': IFile,
  'upload': IFile,

  // UF
  'state': IUf,
  'uf': IUf,
  'estado': IUf,

  // Bilhete Fake (display-only)
  'fake_ticket': IFakeTicket,

  // Disclaimer (display-only)
  'disclaimer': IDisclaimer,

  // Instruções (display-only)
  'instrucoes': IInstrucoes,
};

/**
 * Tenta inferir o tipo do campo baseado no nome
 */
function inferTypeFromName(fieldName) {
  if (!fieldName) return null;

  const name = fieldName.toLowerCase();

  // Email
  if (name.includes('email') || name.includes('e-mail')) return 'email';

  // Telefone
  if (name.includes('phone') || name.includes('telefone') || name.includes('celular') || name.includes('tel_')) return 'phone';

  // CPF
  if (name.includes('cpf') && !name.includes('cnpj')) return 'cpf';

  // CNPJ ou CPF/CNPJ
  if (name.includes('cnpj') || name.includes('documento')) return 'cpf_cnpj';

  // CEP
  if (name.includes('cep') || name.includes('zip')) return 'cep';

  // Data
  if (name.includes('date') || name.includes('data') || name.includes('birth') || name.includes('nascimento')) return 'date';

  // Estado/UF
  if (name.includes('state') || name.includes('estado') || name === 'uf') return 'state';

  return null;
}

/**
 * Retorna o componente Vue para um field
 */
export function getComponentForField(field) {
  // Tenta obter o tipo de várias formas possíveis
  let fieldType = field.type || field.fieldType?.name || field.field_type?.name || field.config?.type;

  // Se ainda não tem tipo, tenta inferir pelo nome do campo
  if (!fieldType) {
    fieldType = inferTypeFromName(field.name);
  }

  const component = FIELD_COMPONENT_MAP[fieldType];

  if (!component) {
    console.warn(`Componente não encontrado para field.type="${fieldType}". Usando i-text como fallback.`);
    return IText;
  }

  return component;
}

/**
 * Prepara props do campo para o componente
 */
export function getFieldProps(field, formData) {
  return {
    label: field.label,
    placeholder: field.placeholder,
    isRequired: field.required,
    isDisabled: field.disabled || field.readonly,
    value: formData[field.name],

    // Para select/radio/checkbox
    options: field.options || [],

    // Para campos com máscara
    mask: field.mask,

    // Help text
    helpText: field.help_text,
  };
}

/**
 * Converte cols do backend (12, 6, 4, 3) para classes Tailwind
 */
export function getFieldTailwindClass(field) {
  const cols = field.layout?.cols || '12';

  // Mapeamento de cols para Tailwind (mobile-first)
  const colsMap = {
    '12': 'col-span-12', // 100% width
    '6': 'col-span-12 md:col-span-6', // 100% mobile, 50% desktop
    '4': 'col-span-12 md:col-span-4', // 100% mobile, 33% desktop
    '3': 'col-span-12 md:col-span-3', // 100% mobile, 25% desktop
  };

  return colsMap[cols] || colsMap['12'];
}
